import { ReactElement, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";
import { PageContainer } from "../../components/shared/layout/LayoutElements";
import { Snackbar } from "@material-ui/core";
import SnackbarErrorContext from "../../components/shared/SnackbarErrorContext";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import UserActionsPageParams from "./models/UserActionsPageParams";
import { useAppSelector } from "../../store/reducers/userDetailsReducer";
import UserActions from "../../components/app/UserActions";

const UserActionsPage = (): ReactElement => {
  const [snackbarErrorMessageKey, setSnackbarErrorMessageKey] = useState("");
  const { t } = useTranslation();
  const { id } = useParams<UserActionsPageParams>();
  const { user } = useAppSelector((state) => state.UserState);

  return (
    <>
      <PageContainer>
        <Snackbar
          open={snackbarErrorMessageKey.length !== 0}
          autoHideDuration={10000}
          onClose={() => setSnackbarErrorMessageKey("")}
        >
          <MuiAlert elevation={6} variant="filled" severity="error">
            {t(snackbarErrorMessageKey)}
          </MuiAlert>
        </Snackbar>
        <SnackbarErrorContext.Provider
          value={{
            snackbarErrorMessageKey,
            setSnackbarErrorMessageKey
          }}
        >
          <UserActions id={id || user?.id || ""} />
        </SnackbarErrorContext.Provider>
      </PageContainer>
    </>
  );
};

export default UserActionsPage;
